import { Types } from '../actionTypes';
import _nav from '../../_nav';

export const sidebarItemsActions = {

  
    getSidebarItems: () => { return (dispatch,getState) => { 
       const state =getState();
       //console.log(state);
      // !user.loginUser.user.token?
      
      //       dispatch({type:Types.GET_SIDEBAR_ITEMS,payload:[]})
      // :
      
      //not working trying  a new
      //  navigation.map((element) => {
      //    return {...element, subElements:element.subElements? element.subElements.filter((subElement) => subElement.perm === user.perm.contains(subElement.perm)):null}
      //  })
    //console.log(navigation);
    //Old method to check 1 permission code
 //   const res = _nav.filter(x =>
 //     x.items ?
        
 //         x.items = x.items.filter(y =>
 //           //   console.log("printing----"+y.perm),
 //           y.items ?
 //             y.items = y.items.filter(z =>
 //               state.loginUser.user.perm.includes(z.perm))
 //           :state.loginUser.user.perm.includes(y.perm)
 //           //state.loginUser.user.perm.indexof(y.perm)<0
 //         )
        
 //      ://console.log(x.perm)
 //      state.loginUser.user.perm.includes(x.perm)
       
 //)
   //new method to check permissions from array of permissions
    const res = _nav.filter(x =>
      x.items ?

        x.items = x.items.filter(y =>
          //   console.log("printing----"+y.perm),
          y.items ?
            y.items = y.items.filter(z =>
              Array.isArray(z.perm) ?
                state.loginUser.user.perm.some(elz=>z.perm.includes(elz))
                : state.loginUser.user.perm.includes(z.perm))

            : Array.isArray(y.perm) ?
              state.loginUser.user.perm.some(ely => y.perm.includes(ely))
              : state.loginUser.user.perm.includes(y.perm)
          //state.loginUser.user.perm.indexof(y.perm)<0
        )

        ://console.log(x.perm)
        Array.isArray(x.perm) ?
          state.loginUser.user.perm.some(elx => x.perm.includes(elx)):
        state.loginUser.user.perm.includes(x.perm)

    )

// const res = navigation.filter(x => 
//    x._children?
   
//   x._children= x._children.filter(function(item){
//   console.log("------------");
//       console.log(state.loginUser.user.perm);
//       console.log(item.perm)
//   var f=   state.loginUser.user.perm.includes(item.perm);
//   console.log(f);
//   return f;
     
//    })
      
   //      ://console.log(x.perm)
   //      state.loginUser.user.perm.includes(x.perm)
        
  
   //  );
 


    //console.log("side bar called" + _nav);
          dispatch({type:Types.GET_SIDEBAR_ITEMS,payload:res});

      

    //     axios.post(process.env.REACT_APP_ENDPOINT + "api/audit/GetAuditChecklist", axiosConfig) 
    //           .then(res => 
    //            {
    //              if(res.data)
    //               {
    //                 dispatch({ type: Types.GET_AUDIT_CHECKLIST, payload:  res  });
                  
    //               }
  
                  
    //           })
    //           .catch(error => {
    //               if (error.response.status === 401) {
    //                 console.log(error);
    //                 //addToast("Something went wrong while fetching records ", { appearance: "error", autoDismiss: true }); 
    //               }
  
    //           });
       };
       
  },

  delSidebarItems: () => {
    return dispatch => {
      dispatch({ type: Types.DEL_SIDEBAR_ITEMS, payload: [] });

    }
  }
    
  }
